Ext.define('SA.data.BusinessSearches', {
    extend: 'SA.data.List',
    singleton: true,

    callbacks: new SA.data.CallbackSet(),
    fieldMappings: {},
    indexField: 'id',

    add(item) {
        item.localTime = +new Date();

        this.callParent([item]);
    },

    buildName({conditions, booleanOperator}) {
        var nameParts = [],
            formatNumber = Ext.util.Format.numberRenderer('0,000'),
            operators = {
                '>=': '\u2265',
                '<=': '\u2264',
                '<>': '\u2260',
                '~': 'contains',
                startswith: 'starts with'
            };

        conditions.forEach(condition => {
            var field = condition[1],
                value = condition[2],
                operator = condition[0],
                description;

            switch (field) {
                case 'keyword':
                    nameParts.unshift(value);

                    return;

                case 'name':
                break;

                case 'numberOfEmployees':
                case 'salesVolume':
                    value = formatNumber(value);
                break;

                case 'naics':
                    description = SA.data.NaicsCodes.getDescription(value);
                break;

                case 'sic':
                    description = SA.data.SicCodes.getDescription(value);
                break;


                            }

            if (conditions.length === 1 && description) {
                value += ', ' + description;
            }

            nameParts.push({
                naics: 'NAICS',
                name: 'name',
                numberOfEmployees: '# of local employees',
                salesVolume: 'sales volume',
                sic: 'SIC'
            }[field] + ' ' + (operators[operator] || operator) + ' ' + value);
        });

        return nameParts.join(' ' + booleanOperator + ' ');
    },

    create({conditions, booleanOperator = 'and'}) {
        var matchAll = booleanOperator === 'and',
            country = SA.AppController.getCurrentCountryCode(),
            name = this.buildName({conditions, booleanOperator}),
            search = {country, name, conditions, matchAll},
            duplicate = this.getAll().find(existingSearch => this.equalSearches(existingSearch, search));

        if (duplicate) {
            this.updateTimestamp(duplicate);
            return Promise.resolve(duplicate);
        }

        return this.requestCreate(search).then(search => {
            SA.data.BusinessSearches.add(search);

            return search;
        });
    },

    createForCode({type, code}) {
        return this.create({conditions: [['=', type, code]]});
    },

    createForString(string) {
        return this.create({conditions: [['~', 'keyword', string]]});
    },

    equalSearches(searchA, searchB) {
        return ['name', 'country', 'conditions', 'matchAll']
            .every(property => equals(searchA[property], searchB[property]));

        function equals(a, b) {
            if (a === b) {
                return true;
            }

            if (Array.isArray(a) && Array.isArray(b) && a.length === b.length) {
                return a.every((aItem, index) => equals(aItem, b[index]));
            }

            return false;
        }
    },

    getAttributeSeries({country, field}) {
        return this.fieldMappings[country][field] || field;
    },

    getCalibrationScore(search, fn, scope) {
        search = this.get(search);

        if (search.calibrationScore != null) {
            return search.calibrationScore;
        }

        this.callbacks.add(fn, scope);

        if (this.calibrating) {
            return;
        }

        this.calibrating = true;

        this.runEstimate(search.country, this.toQuery(search), locations => {
            this.calibrating = false;

            search.calibrationScore = locations;

            this.callbacks.run();
        });
    },

    isFieldAllowed(country, field) {
        return !!this.fieldMappings[country][field];
    },

    loadAll({projectsReadyPromise}) {
        var requests = [],
            limit, searches;

        requests.push(SA.Ajax.request({
            resource: 'businessSearchFields',

            success: fields => {
                this.fieldMappings = fields;
            }
        }));

        requests.push(SA.Ajax.request({
            resource: 'user/businessSearches/limit',

            success: lim => {
                limit = lim;
            }
        }));

        requests.push(SA.Ajax.request({
            resource: 'user/businessSearches',

            success: ss => {
                searches = ss.sort((s1, s2) => s1.lastUsed - s2.lastUsed);
            }
        }));

        return Promise.all(requests).then(() => {
            searches.forEach(this.add, this);

            return projectsReadyPromise.then(() => {
                var projects = SA.data.Projects.getAll(),
                    remove = this.getAll().slice(limit).filter(search => {
                        var id = search.id;

                        return !projects.some(project => project.getBusinessSearches().includes(id));
                    });

                if (remove.length) {
                    remove.forEach(item => {
                        this.remove(item);
                    });

                    return SA.Ajax.request({
                        data: Ext.Array.pluck(remove, 'id'),
                        method: 'delete',
                        resource: 'user/businessSearches'
                    });
                }
            });
        });
    },

    mapQueryFields(country, data) {
        data = Object.assign({}, data);

        if (data.sort) {
            data.sort = data.sort.map(toAttributeSeries);
        }

        if (data.select) {
            data.select = data.select.map(toAttributeSeries);
        }

        if (data.filter) {
            data.filter = toAttributeSeries(data.filter);
        }

        if (data.locationSeries) {
            data.locationSeries = toAttributeSeries(data.locationSeries);
        }

        if (data.aggregates) {
            data.aggregates = data.aggregates.map(aggregate => {
                aggregate = Object.assign({}, aggregate);

                if (aggregate.aggregateBy) {
                    aggregate.aggregateBy = aggregate.aggregateBy.map(toAttributeSeries);
                }

                if (aggregate.locationSeries) {
                    aggregate.locationSeries = toAttributeSeries(aggregate.locationSeries);
                }

                return aggregate;
            });
        }

        return data;

        function toAttributeSeries(expression) {
            if (typeof expression === 'string') {
                return SA.data.BusinessSearches.getAttributeSeries({country, field: expression});
            }

            switch (expression[0]) {
                case 'and':
                case 'or':
                    expression = [expression[0]].concat(expression.slice(1).map(toAttributeSeries));
                break;

                case 'radius':
                case 'within':
                break;

                default:
                    expression = expression.slice();

                    expression[1] = toAttributeSeries(expression[1]);
            }

            return expression;
        }
    },

    async requestCreate(search) {
        var method = 'create',
            resource = 'user/businessSearches',
            results = await SA.Ajax.request({method, resource, data: [search]});

        return results[0];
    },

    runEstimate(country, query, cb) {
        SA.Ajax.request({
            method: 'estimate',
            resource: 'data/locationsFiltered',
            data: this.mapQueryFields(country, {filter: query}),
            success: ({locations}) => cb(locations)
        });
    },

    setName(search, name) {
        search = this.get(search);

        if (search.name === name) {
            return;
        }

        search.name = name;

        this.fireEvent('change');
        this.fireEvent('change:name', search);

        SA.Ajax.request({
            method: 'update',
            resource: 'user/businessSearches',

            data: [{
                id: search.id,
                name: search.name
            }]
        });
    },

    toQuery(search) {
        if (typeof search === 'number') {
            search = this.get(search);
        }

        if (!search) {
            return search;
        }

        var sicAttributes = ['primary_sic', 'sic2', 'sic3', 'sic4', 'sic5', 'sic6'],
            naicsAttributes = ['primary_naics', 'naics2', 'naics3', 'naics4', 'naics5', 'naics6'],
            country = search.country,
            query;

        query = search.conditions.map(condition => {
            var field = condition[1],
                value = condition[2],
                operator = condition[0],
                attributes;

            switch (field) {
                case 'keyword':
                    condition = [
                        'or',
                        ['~', 'names', value],
                        ['~', 'code_descriptions', value]
                    ];

                    if (/^\d+$/.test(value)) {
                        if (SA.data.SicCodes.forCountry(country).some(entry => {
                            return entry[0].startsWith(value);
                        })) {
                            operator = value.length === 8 ? '=' : 'startswith';

                            sicAttributes.forEach(code => {
                                condition.push([operator, code, value]);
                            });
                        }

                        if (SA.data.NaicsCodes.forCountry(country).some(entry => {
                            return entry[0].startsWith(value);
                        })) {
                            operator = value.length === 6 ? '=' : 'startswith';

                            naicsAttributes.forEach(code => {
                                condition.push([operator, code, value]);
                            });
                        }
                    }

                    return condition;

                case 'name':
                    switch (operator) {
                        case 'startswith':
                            attributes = ['legal_name', 'business_name'];
                        break;

                        case '~':
                            attributes = ['names'];
                        break;


                                            }
                break;

                case 'salesVolume':
                    attributes = ['sales_volume'];
                break;

                case 'numberOfEmployees':
                    attributes = ['local_employees'];
                break;

                case 'naics':
                    attributes = naicsAttributes;
                break;

                case 'sic':
                    attributes = sicAttributes;
                break;


                            }

            condition = attributes.map(attribute => [operator, attribute, value]);

            if (condition.length === 1) {
                condition = condition[0];
            }
            else {
                condition.unshift('or');
            }

            return condition;
        });

        if (query.length < 2) {
            query = query[0];
        }
        else {
            query.unshift(search.matchAll ? 'and' : 'or');
        }

        return query;
    },

    updateTimestamp(search) {
        search = this.get(search);

        var items = this.items,
            index = items.indexOf(search),
            now = +new Date();

        if (index === 0 && now - search.localTime < 5000) {
            return;
        }

        search.localTime = now;

        if (index) {
            search.lastUsed = items[0].lastUsed + 1;
            items.splice(index, 1);
            items.unshift(search);

            this.fireEvent('change');
        }

        SA.Ajax.request({
            data: {id: search.id},
            method: 'used',
            resource: 'user/businessSearches'
        });
    }
});